import script from "./UserVipInfoBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserVipInfoBtn.vue?vue&type=script&setup=true&lang=ts"

import "./UserVipInfoBtn.vue?vue&type=style&index=0&id=9c98e4f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c98e4f8"]])

export default __exports__